var wsClass = null;
var runtime = 'web';
export function getWsClass() {
    return wsClass;
}
export function setWsClass(val) {
    wsClass = val;
}
export function getRuntime() {
    return runtime;
}
export function setRuntime(val) {
    runtime = val;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbW1vbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFJLE9BQU8sR0FBRyxJQUFJLENBQUE7QUFDbEIsSUFBSSxPQUFPLEdBQUcsS0FBSyxDQUFBO0FBRW5CLE1BQU0sVUFBVSxVQUFVO0lBQ3hCLE9BQU8sT0FBTyxDQUFBO0FBQ2hCLENBQUM7QUFDRCxNQUFNLFVBQVUsVUFBVSxDQUFDLEdBQVE7SUFDakMsT0FBTyxHQUFHLEdBQUcsQ0FBQTtBQUNmLENBQUM7QUFFRCxNQUFNLFVBQVUsVUFBVTtJQUN4QixPQUFPLE9BQU8sQ0FBQTtBQUNoQixDQUFDO0FBQ0QsTUFBTSxVQUFVLFVBQVUsQ0FBQyxHQUFXO0lBQ3BDLE9BQU8sR0FBRyxHQUFHLENBQUE7QUFDZixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsibGV0IHdzQ2xhc3MgPSBudWxsXG5sZXQgcnVudGltZSA9ICd3ZWInXG5cbmV4cG9ydCBmdW5jdGlvbiBnZXRXc0NsYXNzKCkge1xuICByZXR1cm4gd3NDbGFzc1xufVxuZXhwb3J0IGZ1bmN0aW9uIHNldFdzQ2xhc3ModmFsOiBhbnkpIHtcbiAgd3NDbGFzcyA9IHZhbFxufVxuXG5leHBvcnQgZnVuY3Rpb24gZ2V0UnVudGltZSgpIHtcbiAgcmV0dXJuIHJ1bnRpbWVcbn1cbmV4cG9ydCBmdW5jdGlvbiBzZXRSdW50aW1lKHZhbDogc3RyaW5nKSB7XG4gIHJ1bnRpbWUgPSB2YWxcbn1cbiJdfQ==